module.exports = __webpack_public_path__ + "fonts/Overpass-Regular.0807de33.ttf";